import { notificationService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

// eslint-disable-next-line no-unused-vars
export const createNotification = async ({ commit }, payload) => {
  var response = {};
  try {
    response = await notificationService.create(payload);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
  return response;
};
